import { EditOutlined } from '@ant-design/icons'
import { useState } from 'react'
import { CategoriesMassiveEdit } from './CategoriesMassiveEdit';
import { Alert } from 'antd';


export const CategoriesMassive = (props: { primaryCategory: string, additionalCategories: string[], locationsIds: string[] }) => {
    
    const handleCancel = () => {     
        setEdit(false);
    }

    const handleSuccess = () => {
        setEdit(false);
    }
    const [edit, setEdit] = useState(false);

return (
    <div>
        <Alert message={<><div>La edición de las <b>categorías</b> pueden implicar una re-verificación del negocio por parte de Google. 
				<a href='https://support.google.com/business/answer/7107242?hl=es' target={'_blank'}> Verifica tu negocio en Google</a></div></>} type="warning" showIcon />								
			<br/>
       	<span onClick={() => setEdit(true)} style={{ display:"block",width:"100%",textDecoration: "none", fontSize: "16px", color: "#3C4043", cursor:"pointer", fontWeight:500 }}>Categorias 
            {!edit &&<EditOutlined />}
        </span>
        {edit && 
        <CategoriesMassiveEdit 
            locationsIds = {props.locationsIds}            
            handleSuccess = {handleSuccess}
            handleCancel = {handleCancel} />     
        }           
    </div>
)
}